import { render, staticRenderFns } from "./CarrierSuus.vue?vue&type=template&id=1c2b931e&scoped=true&"
import script from "./CarrierSuus.vue?vue&type=script&lang=js&"
export * from "./CarrierSuus.vue?vue&type=script&lang=js&"
import style0 from "./CarrierSuus.vue?vue&type=style&index=0&id=1c2b931e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2b931e",
  null
  
)

export default component.exports